import {defineStore} from "pinia";
import * as DestinationService from "@/services/destination.service";
import {nextTick, ref} from "vue";
import {useRouter} from "vue-router";
import router from "@/router/router";


export const useDestinationStore = defineStore('destinations', () => {
    const loading = ref(false);
    const loadingSelected = ref(false);
    const allDestinations = ref([]);
    const selectedDestSlug = ref('');
    const selectedDest = ref(null)

    const router = useRouter();

    async function getAllDestinations() {
        loading.value = true;
        try {
            const response = await DestinationService.getAllDestinations();

            if (!response) {
                console.error("Destinations not found");
                allDestinations.value = [];
                return null;
            }
            allDestinations.value = response;
            console.log("Destinations loaded in store:", allDestinations.value);
        } catch (error) {
            console.error("Error fetching destinations:", error);
            allDestinations.value = [];
        } finally {
            loading.value = false;
        }
    }

    async function fetchSelectedDest(slug: string) {
        selectedDestSlug.value = slug
        loadingSelected.value = true;
        try {
            const destination = await allDestinations.value.find((d) => d.slug === selectedDestSlug.value)

            if (!destination) throw new Error('Destination not found')
            console.log("Selected dest: ", destination)
            selectedDest.value = destination;
        } catch (error) {
            console.error("Error fetching destination:", error);
        } finally {
            loadingSelected.value = false;
        }
    }


    // const viewDestination = async (slug: string, destName: string) => {
    //     await fetchSelectedDest(slug);
    //     if(destName !== '') router.push({ path: `/destinations/${slug}`, query: { scrollTo: destName } });
    //     else router.replace({ path: `/destinations/${slug}`, query: {} });
    //
    // };

    const viewDestination = async (slug: string, destName: string) => {
        await fetchSelectedDest(slug);

        const targetRoute = {
            path: `/destinations/${slug}`,
            query: destName ? { scrollTo: destName } : {},
        };

        // Wait for navigation to finish
        await router.push(targetRoute);

        // Scroll to element or to top
        if (destName) {
            // Scroll to destination element
            nextTick(() => {
                const el = document.getElementById(destName);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        } else {
            // Scroll to top
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };


    return {
        allDestinations,
        loading,
        getAllDestinations,
        fetchSelectedDest,
        selectedDestSlug,
        selectedDest,
        loadingSelected,
        viewDestination
    };
});
